import PropTypes from "prop-types";
import React, { Component } from "react";
import { Card, CardBody, Col, Container, Label, Row } from "reactstrap";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { Field, Form, Formik, ErrorMessage } from "formik";
import { getUserDefinitionByGuid, updateUserDefinitionNewPassword, userDefinitionNewPasswordApiError } from "../../store/actions";
import profile from "../../assets/images/profile-img.png";
import {
    ErrorModal,
    MessageBoxModal
} from "../../components/Common/CombinedComponents";
import * as Yup from "yup";
import * as YupPassword from "yup-password";
YupPassword(Yup);

class PasswordChangeConfirm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recordList: [],
            record: "",
            messageBoxModal: false,
            buttonDisabled: false,
        };
        this.handleValidSubmit = this.handleValidSubmit.bind(this);
    }


    handleValidSubmit(values) {
        const { onUpdateUserRecord, record } = this.props;
        let data = {
            newPassword: values.password,
            userGuid: record.guid
        }
        this.setState({ buttonDisabled: true });
        onUpdateUserRecord(data);
    }


    componentDidMount() {
        this.props.apiError("");

        const { onGetUserRecord } = this.props;
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const confirmToken = params.get("token");
        onGetUserRecord(confirmToken);
    }

    componentDidUpdate(prevProps) {
        const { error, waitingRecordListUpdate, record, waitingGetUserUpdate } = this.props;
        if (prevProps.error !== error) {
            this.setState({ error: error });
        }
        if (prevProps.waitingRecordListUpdate !== waitingRecordListUpdate) {
            this.setState({ messageBoxModal: true });
        }
        if (prevProps.waitingGetUserUpdate !== waitingGetUserUpdate) {
            this.setState({ record: record });
        }
    }

    onLoginLinkClick = e => {
        e.preventDefault();
        this.setState({ messageBoxModal: false });
        this.props.history.push("/login");
    };

    render() {
        const { error, messageBoxModal, buttonDisabled } = this.state;
        return (
            <React.Fragment>
                {error && (
                    <ErrorModal
                        errorMessage={error}
                        onCloseModalClick={() => this.setState({ error: undefined })}
                    />
                )}
                <MessageBoxModal
                    messageText={this.props.t("yourPasswordHasBeenChanged")}
                    messageDetailText={
                        this.props.t("loginWithYourNewPassword")
                    }
                    show={messageBoxModal}
                    onCloseClick={this.onLoginLinkClick}
                />
                <div className="account-pages my-5 pt-sm-5" style={{ backgroundColor: "white" }}>
                    <Container>
                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="overflow-hidden">
                                    <div style={{ backgroundColor: "#AB63BF" }}>
                                        <Row>
                                            <Col className="col-7">
                                                <div className="text-primary p-4">
                                                    <h5 style={{ color: "#FAF3FD" }}>
                                                        {this.props.t("passwordChangeConfirm")}
                                                    </h5>
                                                </div>
                                            </Col>
                                            <Col className="col-5 align-self-end">
                                                <img src={profile} alt="" className="img-fluid" />
                                            </Col>
                                        </Row>
                                    </div>
                                    <CardBody className="pt-0" style={{ backgroundColor: "#FAF3FD" }}>
                                        <br></br>
                                        <div className="p-2">
                                            <Formik
                                                initialValues={{
                                                    password: "",
                                                }}
                                                validationSchema={Yup.object().shape({
                                                    password: Yup.string()
                                                        .strict(true)
                                                        .max(
                                                            256,
                                                            this.props.t("maxLengthError").format("256"),
                                                        )
                                                        .min(8, this.props.t("minLengthError").format("8"))
                                                        .minRepeating(
                                                            2,
                                                            this.props.t("passwordValidation5"),
                                                        )
                                                        .minLowercase(
                                                            1,
                                                            this.props.t("passwordValidation1"),
                                                        )
                                                        .minUppercase(
                                                            1,
                                                            this.props.t("passwordValidation2"),
                                                        )
                                                        .minNumbers(1, this.props.t("passwordValidation3"))
                                                        .minSymbols(1, this.props.t("passwordValidation4"))
                                                        .required(this.props.t("mustBe")),
                                                })}
                                                enableReinitialize={true}
                                                onSubmit={values => {
                                                    this.handleValidSubmit(values)
                                                }}
                                            >
                                                {({ errors, touched, setFieldValue }) => (
                                                    <Form>
                                                        <Row>
                                                            <Col lg={12} className="col-12">
                                                                <div className="mb-3">
                                                                    <Label className="form-label">
                                                                        {this.props.t("newPassword")}
                                                                    </Label>
                                                                    <Field
                                                                        name="password"
                                                                        type="password"
                                                                        className={
                                                                            "form-control" +
                                                                            (errors.password && touched.password
                                                                                ? " is-invalid"
                                                                                : "")
                                                                        }
                                                                    />
                                                                    <ErrorMessage
                                                                        name="password"
                                                                        component="div"
                                                                        className="invalid-feedback"
                                                                    />
                                                                </div>
                                                                <div className="mt-3 d-grid">
                                                                    <i className="mdi mdi-check" style={{ color: "gray" }}>
                                                                        {this.props.t("passwordValidation1")}
                                                                    </i>
                                                                    <i className="mdi mdi-check" style={{ color: "gray" }}>
                                                                        {this.props.t("passwordValidation2")}
                                                                    </i>
                                                                    <i className="mdi mdi-check" style={{ color: "gray" }}>
                                                                        {this.props.t("passwordValidation3")}
                                                                    </i>
                                                                    <i className="mdi mdi-check" style={{ color: "gray" }}>
                                                                        {this.props.t("passwordValidation4")}
                                                                    </i>
                                                                    <i className="mdi mdi-check" style={{ color: "gray" }}>
                                                                        {this.props.t("passwordValidation5")}
                                                                    </i>
                                                                </div>
                                                            </Col>
                                                            <Col lg={12} className="col-12">
                                                                <div className="mt-3 d-grid">
                                                                    <br></br>
                                                                    <button
                                                                        className="btn btn-backgroundColor btn-block"
                                                                        type="submit" disabled={buttonDisabled}
                                                                        style={{ backgroundColor: "#AB63BF", color: "#FAF3FD" }}
                                                                    >
                                                                        {this.props.t("passwordChangeUpdate")}
                                                                    </button>
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Form>
                                                )}
                                            </Formik>
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}


PasswordChangeConfirm.propTypes = {
    record: PropTypes.any,
    onGetUserRecord: PropTypes.func,
    onUpdateUserRecord: PropTypes.func,
    className: PropTypes.any,
    apiError: PropTypes.any,
    error: PropTypes.any,
    t: PropTypes.any,
    waitingRecordListUpdate: PropTypes.any,
    waitingGetUserUpdate: PropTypes.any,
    history: PropTypes.any,
};

const mapStateToProps = ({ userDefinitionPassword }) => ({
    error: userDefinitionPassword.error,
    record: userDefinitionPassword.record,
    waitingRecordListUpdate: userDefinitionPassword.waitingRecordListUpdate,
    waitingGetUserUpdate: userDefinitionPassword.waitingGetUserUpdate
});

const mapDispatchToProps = dispatch => ({
    onGetUserRecord: passwordSign => dispatch(getUserDefinitionByGuid(passwordSign)),
    onUpdateUserRecord: record => dispatch(updateUserDefinitionNewPassword(record)),
    apiError: error => dispatch(userDefinitionNewPasswordApiError(error)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withTranslation()(PasswordChangeConfirm));
